export default "<p>regular-manual-rostering works!</p>\r\n";